(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq-accordion"] && !Shopify.designMode) return;
  try {
    
  (function() {
    // Small delay to allow theme scripts / DOM to load
    setTimeout(function() {
      if (!window.jQuery) {
        console.error('jQuery not loaded. FAQ accordion will not work.');
        return;
      }

      // Scope to the exact section container (no trailing spaces)
      var sectionSelector = '#faq-section-{{ section.id }}';
      var $section = jQuery(sectionSelector);

      if ($section.length === 0) {
        // Fallback to shopify-section id if the wrapper isn't present
        $section = jQuery('#shopify-section-{{ section.id }}');
      }

      if ($section.length === 0) {
        console.error('FAQ section container not found for id: {{ section.id }}');
        return;
      }

      // Cache elements inside this section only
      var $questions = $section.find('.faq-question');
      var $answers = $section.find('.faq-answer');

      // Ensure all answers are hidden initially and aria attributes set
      $answers.each(function() {
        var $ans = jQuery(this);
        $ans.hide();
        var id = $ans.attr('id');
        // set aria-hidden for screen readers
        $ans.attr('aria-hidden', 'true');
        // find associated button and reset aria-expanded
        var $btn = $section.find('[aria-controls="' + id + '"]');
        $btn.attr('aria-expanded', 'false');
      });

      // Click handler (works when clicking the question or the icon inside)
      $section.on('click', '.faq-question', function(e) {
        e.preventDefault();
        var $btn = jQuery(this);
        var targetId = $btn.attr('aria-controls');
        if (!targetId) return;

        var $target = $section.find('#' + targetId);
        var isOpen = $btn.attr('aria-expanded') === 'true';

        if (isOpen) {
          // Close this
          $target.slideUp(250, function() {
            $target.attr('aria-hidden', 'true');
            $btn.attr('aria-expanded', 'false');
          });
        } else {
          // Close any open items first (accordion behavior)
          $section.find('.faq-question[aria-expanded="true"]').each(function() {
            var $otherBtn = jQuery(this);
            var otherTargetId = $otherBtn.attr('aria-controls');
            var $otherTarget = $section.find('#' + otherTargetId);
            $otherTarget.slideUp(200);
            $otherBtn.attr('aria-expanded', 'false');
            $otherTarget.attr('aria-hidden', 'true');
          });

          // Open clicked
          $target.slideDown(300, function() {
            $target.attr('aria-hidden', 'false');
            $btn.attr('aria-expanded', 'true');
          });
        }
      });

      // Optional: allow Enter/Space to toggle when focused (good for keyboard users)
      $section.on('keydown', '.faq-question', function(e) {
        var code = e.which || e.keyCode;
        if (code === 13 || code === 32) { // Enter or Space
          e.preventDefault();
          jQuery(this).trigger('click');
        }
      });

    }, 120); // 120ms
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
